export const cloneControl = {
  defaultButton: `Cloner`,
  defaultNoun: `paramètres`,
  itemNounDefault: `ces paramètres`,
  pullTitle: `Importer les paramètres d'une autre annonce`,
  pushTitle: `Copier ces paramètres vers une autre annonce`,
  pullSubReplace: `Ils seront appliqués à cette annonce`,
  pullSubAdd: `Ils seront ajoutés à ceux de cette annonce`,
  pushSubReplace: `Ils seront appliqués à celles que vous choisissez`,
  pushSubAdd: `Ils seront ajoutés à celles que vous choisissez`,
  pullTitleFull: `Importer {noun}`,
  pushTitleFull: `Copier {noun}`,
  pullSubtitle: `Choisissez l'annonce depuis laquelle importer les paramètres. Ils seront appliqués à celle-ci.`,
  pushSubtitle: `Copiez ces paramètres vers les annonces que vous choisissez.`,
};
